<script setup lang="ts">
    import type { PrimitiveProps } from 'reka-ui';
    import type { Component, HTMLAttributes } from 'vue';
    import type { ButtonVariants } from '.';
    import { Primitive } from 'reka-ui';
    import { cn } from '../utils';
    import { buttonVariants } from '.';
    import { LoaderCircle } from 'lucide-vue-next';

    type Props = PrimitiveProps & {
        variant?: ButtonVariants['variant'];
        size?: ButtonVariants['size'];
        class?: HTMLAttributes['class'];
        loading?: ButtonVariants['loading'];
        icon?: boolean;
        disabled?: boolean;
        iconLeft?: Component;
        iconRight?: Component;
    };

    const props = withDefaults(defineProps<Props>(), {
        as: 'button',
    });
</script>

<template>
    <Primitive
        data-slot="button"
        :as="as"
        :as-child="asChild"
        :class="cn(buttonVariants({ variant, size, icon: !!icon, loading }), props.class)"
        :disabled="disabled"
    >
        <slot name="iconLetf">
            <component
                :is="iconLeft"
                v-if="iconLeft"
            />
        </slot>

        <div :class="cn(size === 'sm' ? 'px-1' : 'px-2', icon && 'p-0')">
            <slot />
        </div>

        <slot name="iconRight">
            <component
                :is="iconRight"
                v-if="iconRight"
            />
        </slot>

        <div
            v-if="loading"
            class="absolute inset-0 flex items-center justify-center visible!"
        >
            <LoaderCircle data-spinner />
        </div>
    </Primitive>
</template>
